"use client";

import { ROUTER_PATH } from "@/src/config/router";
import { setEdgenOnboardingStepCookie } from "@/src/utils/onboarding";

type PlanRouter = {
  replace: (href: string) => void;
};

/**
 * Unlock / 关墙承接：离开 onboarding 落 Plan·Activity。
 * 须先将 step cookie 置 3，否则 Proxy 会把主站路由打回 /onboarding。
 */
export function navigateOnboardingPlanUnlockToPlan(router: PlanRouter): void {
  setEdgenOnboardingStepCookie(3);
  router.replace(ROUTER_PATH.PLAN_MY_GOALS);
}

/**
 * @deprecated Prefer {@link navigateOnboardingPlanUnlockToPlan} — V3.0.3 关墙承接改落 /plan。
 */
export function navigateOnboardingPlanUnlockToBrief(router: PlanRouter): void {
  navigateOnboardingPlanUnlockToPlan(router);
}
